import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import ClientInfos from "../../components/clients/clientinfos";
import LicencesClient from "../../components/licences/licencesclient";



export default function ViewClient() {
    // states
    let codeclient = useParams();
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);



    const displayPages = () => {
        if (page === 0) {
            return <ClientInfos codeclient={codeclient.code} />;
        } else {
            return <LicencesClient codelcient={codeclient.code} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {

    }, []);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-2 font-weight-bold text_primary">Clients</h1>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                    <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Informations du client</span>
                    </button>
                    <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Licences du client</span>
                    </button>
                    {/* <button onClick={() => {setPage(2)}} className={`btn-shadow rounded-0 btn ${page === 2 ? 'btn-primary' : 'btn-secondary'}`}>
                                    <span>Profils du client</span>
                                </button> */}
                </div>
                {displayPages()}
            </div>}
        </>
    )
}